var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/ticker",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3846154,4 C19.3543994,4 19.9394784,4.87195849 19.9955618,5.84554377 L20,6 L20,18 C20,18.982149 19.4634102,19.9032149 18.5345211,19.9928661 L18.3846154,20 L11,20 C10.4477153,20 10,19.5522847 10,19 C10,18.4871642 10.3860402,18.0644928 10.8833789,18.0067277 L11,18 L18,18 L18,12.999 L6.99937425,12.9998 L8.80037425,15.4008 C9.13137425,15.8418 9.04237425,16.4688 8.60037425,16.7998 C8.42037425,16.9348 8.20937425,16.9998 8.00137425,16.9998 C7.69737425,16.9998 7.39637425,16.8618 7.20037425,16.5998 L7.20037425,16.5998 L4.20037425,12.5998 C3.94037425,12.2538 3.93237425,11.7788 4.18237425,11.4248 L4.18237425,11.4248 L6.99637425,7.4248 C7.31437425,6.9728 7.93837425,6.8628 8.38937425,7.1818 C8.84137425,7.4998 8.95037425,8.1238 8.63237425,8.5748 L8.63237425,8.5748 L6.91437425,11.0178 C6.94437425,11.0148 6.97037425,10.9998 7.00037425,10.9998 L7.00037425,10.9998 L18,10.999 L18,6 L11,6 C10.4477153,6 10,5.55228475 10,5 C10,4.48716416 10.3860402,4.06449284 10.8833789,4.00672773 L11,4 L18.3846154,4 Z",
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicker);
export default __webpack_public_path__ + "static/media/ticker.326f347d.svg";
export { ForwardRef as ReactComponent };